export enum EFaqTabTypes {
  E_UTDIJ = "eUtdij",
  E_MATRICA = "eMatrica",
}
